module.exports = __webpack_public_path__ + "img/notary-journal_B09JR7ZNDG.aed486c2.jpg";